import api from '../utils/api';

export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

export const fetchUsers = () => async (dispatch) => {
  try {
    const res = await api.get('/users');
    dispatch({
      type: FETCH_USERS_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error('Error fetching users:', error);
    // Handle error as needed
  }
};

export const addUser = (userData) => async (dispatch) => {
  try {
    const res = await api.post('/auth/register', userData);
    dispatch({
      type: ADD_USER_SUCCESS,
      payload: res.data.user,
    });
  } catch (error) {
    console.error('Error adding user:', error);
    // Handle error as needed
  }
};

export const updateUser = (userId, userData) => async (dispatch) => {
  try {
    const res = await api.put(`/users/${userId}`, userData);
    dispatch({
      type: UPDATE_USER_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error('Error updating user:', error);
    // Handle error as needed
  }
};

export const deleteUser = (userId) => async (dispatch) => {
  try {
    await api.delete(`/users/${userId}`);
    dispatch({
      type: DELETE_USER_SUCCESS,
      payload: userId,
    });
  } catch (error) {
    console.error('Error deleting user:', error);
    // Handle error as needed
  }
};
